// src/components/InviteModal.jsx
// Modal quản lý thành viên workspace: mời, xem danh sách, hủy mời

import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useWorkspaceInvites } from "../hooks/useInvites";
import toast from "react-hot-toast";
import "../styles/invite.css";

export default function InviteModal({ workspace, members, onClose }) {
  const { user } = useAuth();
  const { sentInvites, cancelInvite } = useWorkspaceInvites(workspace.id);
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  // Import sendInvite từ prop để tránh re-init hook
  const isOwner = workspace.ownerId === user.uid;

  const handleSend = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSending(true);
    try {
      await workspace.sendInvite(workspace.id, workspace.name, email);
      toast.success(`Đã gửi lời mời đến ${email}`);
      setEmail("");
    } catch (err) {
      toast.error(err.message || "Gửi lời mời thất bại.");
    }
    setSending(false);
  };

  const handleCancel = async (inviteId, toEmail) => {
    if (!window.confirm(`Hủy lời mời đến ${toEmail}?`)) return;
    await cancelInvite(inviteId);
    toast.success("Đã hủy lời mời.");
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal invite-modal">
        <div className="modal-header">
          <div>
            <h2 className="modal-title">Thành viên</h2>
            <p className="modal-subtitle">{workspace.name}</p>
          </div>
          <button className="modal-close" onClick={onClose}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M18 6L6 18M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <div className="invite-body">
          {/* Form mời — chỉ owner */}
          {isOwner && (
            <div className="invite-section">
              <h3 className="invite-section-title">Mời thành viên mới</h3>
              <form className="invite-form" onSubmit={handleSend}>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Nhập email Google của họ..."
                  required
                  className="invite-input"
                />
                <button type="submit" className="btn-primary invite-send-btn" disabled={sending}>
                  {sending ? "Đang gửi..." : "Gửi lời mời"}
                </button>
              </form>
              <p className="invite-hint">
                Người được mời đăng nhập vào app sẽ thấy thông báo và có thể chấp nhận.
              </p>
            </div>
          )}

          {/* Danh sách thành viên hiện tại */}
          <div className="invite-section">
            <h3 className="invite-section-title">
              Thành viên ({members.length})
            </h3>
            <div className="member-list">
              {members.map((m) => (
                <div key={m.uid} className="member-item">
                  {m.photoURL ? (
                    <img src={m.photoURL} alt="" className="member-avatar"/>
                  ) : (
                    <div className="member-avatar-fallback">
                      {m.displayName?.charAt(0)}
                    </div>
                  )}
                  <div className="member-info">
                    <span className="member-name">{m.displayName}</span>
                    <span className="member-email">{m.email}</span>
                  </div>
                  {workspace.ownerId === m.uid && (
                    <span className="owner-badge">Owner</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Lời mời đang chờ */}
          {isOwner && sentInvites.length > 0 && (
            <div className="invite-section">
              <h3 className="invite-section-title">
                Đang chờ chấp nhận ({sentInvites.length})
              </h3>
              <div className="pending-list">
                {sentInvites.map((inv) => (
                  <div key={inv.id} className="pending-item">
                    <div className="pending-avatar">
                      {inv.toEmail.charAt(0).toUpperCase()}
                    </div>
                    <span className="pending-email">{inv.toEmail}</span>
                    <button
                      className="cancel-invite-btn"
                      onClick={() => handleCancel(inv.id, inv.toEmail)}
                      title="Hủy lời mời"
                    >
                      Hủy
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
